export const getFileExtensionFromUrl = (url) => {
  const extension = url.substring(url.lastIndexOf(".")).replace(".", "");
  return extension;
}
